import { useQuery } from '@tanstack/react-query';
import type { OrganizerQualitySignalsResponse } from '@/types/creator-quality-signals';
import { withBasePath } from '@/utils/withBasePath';

export function useOrganizerMetrics(organizerId: string | undefined) {
  const id = organizerId?.trim() ?? '';

  return useQuery({
    queryKey: ['organizer-quality-signals', id],
    queryFn: () => fetchOrganizerMetrics(id),
    enabled: id.length > 0,
    retry: false,
    staleTime: 60000, // 1 minute
  });
}

export async function fetchOrganizerMetrics(
  organizerId: string,
): Promise<OrganizerQualitySignalsResponse | null> {
  const res = await fetch(
    withBasePath(`/api/organizers/${encodeURIComponent(organizerId)}/quality-signals/`),
    {
      credentials: 'include',
    },
  );

  if (res.status === 503 || res.status === 502) {
    return null;
  }

  if (!res.ok) {
    throw new Error(`Quality signals request failed: ${res.status}`);
  }

  return (await res.json()) as OrganizerQualitySignalsResponse;
}
